
export const convertIfReadableDate = (value: string): string => {
  // There is a weird JavaScript date bug that returns a valid date when the date string is "Option 1" or "Word 1"
  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
  if (!isoRegex.test(value)) return value;
  const parsedDate = new Date(value);
  if (isNaN(parsedDate.getTime())) return value;
  return parsedDate.toLocaleString('default', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};